var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureAutomation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5",
    x1: 9,
    y1: 177.9,
    x2: 9,
    y2: 160.1,
    gradientTransform: "translate(0 -160)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#0a7cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#2e8ce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#4897e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#589eed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5",
    x1: -26.189,
    y1: -295.6,
    x2: -26.189,
    y2: -311.105,
    gradientTransform: "matrix(1.156 0 0 1.029 39.425 321.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fea11b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#fea51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#feb018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffc314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd70f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 10V8l-.3-.1-2.2-.7-.6-1.4L16 3.4 14.5 2l-.3.1-2 1-1.4-.6L10 .1H8l-.2.3-.7 2.2-1.4.5L3.4 2 2 3.5l.1.3 1 2-.5 1.4L.1 8v2l.3.1 2.2.7.6 1.4L2 14.6 3.5 16l.3-.1 2-1 1.4.6.8 2.4h2l.1-.3.7-2.2 1.4-.6 2.3 1.1 1.4-1.4-.1-.3-1-2 .6-1.4zM9 12.9A3.842 3.842 0 015.1 9 3.842 3.842 0 019 5.1 3.842 3.842 0 0112.9 9 3.842 3.842 0 019 12.9z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5H4.9a.215.215 0 01-.2-.2v-.1L9 1.7c0-.1.1-.1.2-.1h4.2a.215.215 0 01.2.2v.1L8.5 8.6h4.9a.215.215 0 01.2.2.1.1 0 01-.1.1l-8.2 8.5c-.1 0-.6.5-.4-.2z",
    fill: "url(#b)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureAutomation);
export default __webpack_public_path__ + "static/media/azure-automation.8f22bef3b40701b8db316d9b99a0dcb4.svg";
export { ForwardRef as ReactComponent };